import React from 'react'
import './styles.scss'

const HellFire = () => {
  return (
    <div className="absolute w-100 hell-fire">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1000 120.9677"
        className="flame-main"
      >
        <title>hell fire</title>
        <g id="right-fire">
          <path
            className="flame-main three"
            d="M999.5,51.9839c-3.9355.7155-25-4-28-6s-15-4-17-2-9-1-12-6-7-16-8-17c-3,5-4,10-7,15s-9,16-18,16-19-1-22-10c-6-1-15-3-8-21-10,0-23-1-28,3s-19,20-22,22-7,3-9,1a134.996,134.996,0,0,1-9-11c-3-4-7-12-9-11s-7,14-9,14-9,4-11,2-7-4-9-6-9-10-12-11-8,0-10-3-3-16-6-15-14,12-17,15-11,13-16,14-5-1-8,1-4,3-7-2,0-8,0-12-1-9-3-9-7,15-12,17-5,6-8,7-12,4-17,10-6,13-11,16-21,7-21,2,3-12-3-13c-4,6-18,0-18-5-3,6-6,19-10,23s-17,7-19,5-7-5-10-1-12,14-14,10-6-13-3-17,4-16,1-18c-4,6-9,11-11,16s0,19-3,22-10,3-12,2-3-4,0-8c-5,3-21,13-21,23s-4-2-5,0-4,7-8,10-5,71-5,71h545S1043.5,43.9839,999.5,51.9839Z"
            style={{
              fill: '#f05f40',
              stroke: '#000',
              strokeMiterlimit: 10,
              strokeWidth: '3px'
            }}
          />
        </g>
        <g id="left-fire">
          <path
            className="flame-main two"
            d="M3,66.4839s4,2,8-4,18-14,28-13,18,4,23-5,9.6-22.8,11-23c3.5-.5,4.5,14.5,4.5,18.5s2,13,9,8c5-1,10,0,12-4s0-7,6-13,20-19,27-16c1,7,9,19,15,20s2,13,13,3,18-27,20-27,2,9,5,11,7,2,10,2,0,5,11,3c4-1,1,7,15,3,5-2,0,7,17-2,4,4,7,9,12,3s19-28,23-29,8,17,15,17,7-3,10-1,6,1,7,7a10.4715,10.4715,0,0,0,10,9c4,0,5,3,10,3s1,4,5,2,4-4,9-5,6-1,11-2,6,5,21,1,9-6,12-4,4,8,8,10,7,2,11,5,7,3,9,4,5,4,9,5,6,0,10-2,4-27,6-27,10,43,21,45,13-10,18-6,10,10,13,10,10,0,12,2,11-24,31-18c-2,4-17,26-4,27s19-7,23-4c-2,4-5,5-3,8s7,3,10,4,5,7,11,6,8-6,11-5,14,5,9-7c6,6,7,5,12,16s8,14,11,13,13,78,15,81-640-3-640-3S-20.5,51.9839,3,66.4839Z"
            style={{
              fill: '#cf3131',
              stroke: '#000',
              strokeMiterlimit: 10,
              strokeWidth: '3px'
            }}
          />
        </g>
        <g id="center-fire">
          <path
            className="flame-main one"
            d="M3.5,90.9839s4,16,4,20-.4213,14.6719,7.7893,11.8359S25.5,115.9839,33.5,113.9839s15,0,17-2,4-9,7-14,12-8,18-10,17-24,17-30c3,4,6,8,3,16s-8,26,1,28,12-7,16-5,3,7,9,1,11-17,12-27-4-29-5-32,8,10,9,12,11,8,14,24c1,3,5-4,7-3s11,9,16,6,10-5,13-11,15-20,21-22c3-1-5,12-4,15s-2,8,0,9,10,1,13,3,0,7,4,11,27,2,29,0,17-17,20-24,15-20,17-23,4-10,6-9,1,10,2,14,1,12,3,12,6-4,8-3,0,10,4,11,5,0,8,2,5,7,7,5,15-9,19-14,14-13,17-14,16-4,17-2-8,12-5,17,5,3,14,6,16,0,19-4,2-11,4-13,2-7-4-14-10-15-22-13c3-4,23-4,27,0s10,11,13,13,15,6,19,11,7,13,13,11,11-5,14-8,10-2,12-8,2-13,3-16,1-6,3-6,4,6,5,10,1,8,4,13,0,10,5,12,10,2,14,2,11,0,16-4,12-8,14-11,6-6,16-6,9-1,10,0-11,9-9,14,5,5,7,7,11,2,13,3,3,6,14,3,16-11,16-14-2-8,0-9,8,6,15,7,2,10,5,14,1,6,5,8,6-5,9,4c1,3,3,0,7,8,2,3,6-2,12,3s18-12,23-15,12-13,14-13,5,10,5,15-4,16,5,17,6-3,15,2,7-6,10-9,8-6,9-14-3-21-7-25c-2-2,6,5,14,7s9,1,11,8,6,11,6,16,9,3,13,5,10,6,13,1,13-15,27-6c2,2-5,1-5,7s5,13,9,15,10-2,14-2,7,1,8-8,7-13,4-21-4-11-2-11,11,7,15,9,13,15,15,15c-2,5,1,8,11,5s21-7,26-3c3,2-11,7-2,15s16,0,19-3,13-14,16-16,2-7,5-6,10,8,12,11,20,6,25,5c3,5,5,6,8,6s8-9,13-9,17-6,17-9c4,10,13,126-3,128s-1053,6-1053,6,1-96,3-101,16-10,18-16C2.5,86.9839,3.5,90.9839,3.5,90.9839Z"
            style={{
              fill: '#f69d1d',
              stroke: '#000',
              strokeMiterlimit: 10,
              strokeWidth: '3px'
            }}
          />
        </g>
      </svg>
    </div>
  )
}

export default HellFire
